import { n$2, t$2 } from '@/js/global/global'
import { formatMoney } from '@/js/modules/format-money'

const progressOffersSelectors = {
  progressBar: '[data-progress-bar]',
  messageEl: '[data-progress-message]',
  barEl: '.progress-bar',
  progressGoalContainer: '[data-progress-goal-container]',
  progressGoals: '[data-progress-goal]'
}

function progressOffersBar(node) {
  let {
    offerNames,
    offerThresholds,
    cartTotal
  } = node.dataset;

  if (!node) return;

  cartTotal = parseInt(cartTotal, 10);
  offerNames = offerNames.split('|').filter(name => name != '');
  offerThresholds = offerThresholds.split('|').filter(num => num != '-').map(v => {
    return Math.round(parseInt(v, 10) * (window.Shopify.currency.rate || 1)) * 100;
  });

  function getSegmentedProgress(value, goals) {

    // Extend goals so the first 'goal' is 0
    const all = [0, ...goals];
    const max = all[all.length - 1];
    const segments = all.length - 1;

    // Clamp value to max
    const current = Math.min(value, max);

    // Find which segment the current cart value is in
    let segmentIndex = 0;

    for (let i = 0; i < segments; i++) {
      if (current >= all[i] && current <= all[i + 1]) {
        segmentIndex = i;

        break;
      }
    }

    // Fraction inside this segment based on real thresholds
    const segStart = all[segmentIndex];
    const segEnd   = all[segmentIndex + 1];
    const segRange = segEnd - segStart;
    const segProgress = segRange === 0 ? 1 : (current - segStart) / segRange;

    // Convert to evenly spaced visual segments
    const segmentSize = 100 / segments;
    const visual = (segmentIndex * segmentSize) + (segProgress * segmentSize);

    return Math.min(visual, 100);
  }

  const visualPercent = getSegmentedProgress(cartTotal, offerThresholds);

  // Update bar width
  const progressBar = n$2(progressOffersSelectors.progressBar, node);
  progressBar.style.width = visualPercent + '%';

  // Update dots
  const ticks = node.querySelectorAll('.tick');
  const progressGoals = t$2(progressOffersSelectors.progressGoals, node);

  let tickPercent = 0;
  let denominator = ticks.length - 1;

  ticks.forEach((tick, i) => {
    const threshold = Math.round(parseInt(tick.dataset.threshold, 10) * (window.Shopify.currency.rate || 1)) * 100;

    let progressGoal = progressGoals[i - 1];

    if (i !== 0) {
      tickPercent += 100 / denominator;

      // Position dot
      tick.style.left = tickPercent + '%';

      if (progressGoal !== undefined) progressGoal.classList.toggle('reached', cartTotal >= threshold);
    }

    // If last item in array, reset tickPercent
    if (i === ticks.length - 1) {
      tickPercent = 0;
    }

    // Mark reached state
    tick.classList.toggle('reached', cartTotal >= threshold);
  });

  progressGoals.forEach((progressGoal) => {
    progressGoal.style.left = (100 / denominator) / 2 + '%';
  });

  // Update messaging
  const messageEl = n$2(progressOffersSelectors.messageEl, node);

  for (let i = 0; i < offerThresholds.length; i++) {
    // The first of multiple offers is $0
    if (cartTotal == 0 && cartTotal == offerThresholds[0] && offerThresholds[i + 1] !== undefined) {
      messageEl.innerHTML = `You are <strong>${formatMoney(Math.abs(cartTotal - offerThresholds[i + 1]))}</strong> away from: ${offerNames[i + 1]}`;

      return;
    }

    // All other offers
    if (cartTotal < offerThresholds[i]) {
      messageEl.innerHTML = `You are <strong>${formatMoney(Math.abs(cartTotal - offerThresholds[i]))}</strong> away from: ${offerNames[i]}`;

      return;
    }
  }

  messageEl.textContent = offerThresholds.length > 1 ? `Congratulations! Enjoy All Your Gifts!` : `Congratulations! Enjoy Your Gift!`;
}

export { progressOffersBar };